import { Component, OnInit, Input } from '@angular/core';
import { FsItem } from '@web/core/models';
import { FsItemComponent } from '../fs-item.component';

@Component({
  selector: 'prada-fs-list-item',
  templateUrl: './fs-list-item.component.html',
  styleUrls: ['./fs-list-item.component.scss'],
})
export class FsListItemComponent extends FsItemComponent implements OnInit {}
